"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
const feature_1 = require("./feature");
exports.Features = {
    Acquisition: new feature_1.Feature(['FR', 'IT']),
    CashAdvance: new feature_1.Feature(['FR', 'IT']),
    CET: new feature_1.Feature(['FR']),
    CompanyExternalCrm: new feature_1.Feature(['FR', 'IT']),
    CompanyLunchTickets: new feature_1.Feature(['FR', 'IT']),
    CompanyOnFoTsByDefault: new feature_1.Feature(['US']),
    CompanyOrderSettings: new feature_1.Feature(['FR', 'IT']),
    CompanyParentImmutable: new feature_1.Feature(['US']),
    CompanyRequiredEquipments: new feature_1.Feature(['FR', 'IT']),
    CompanyTransportPolicy: new feature_1.Feature(['FR', 'IT']),
    CompanyShippingAddress: new feature_1.Feature(['FR', 'IT']),
    CompanySpecificDayPolicy: new feature_1.Feature(['FR', 'IT']),
    CompensationCode: new feature_1.Feature(['US']),
    Contracts: new feature_1.Feature(['FR', 'IT']),
    ContractsPayrollSystem: new feature_1.Feature(['FR']),
    EmailTemplateBasedOnWorkerLanguage: new feature_1.Feature(['US']),
    FreeApplications: new feature_1.Feature(['FR', 'IT', 'US']),
    InterimCoeffInPercents: new feature_1.Feature(['US']),
    Invoices: new feature_1.Feature(['FR']),
    InvoiceSettings: new feature_1.Feature(['FR', 'IT']),
    InterimReason: new feature_1.Feature(['FR']),
    IziPro: new feature_1.Feature(['FR', 'IT']),
    IziProDefaultContact: new feature_1.Feature(['FR']),
    JobOfferDefaultText: new feature_1.Feature(['FR', 'US']),
    LegalCompanyIdentification: new feature_1.Feature(['FR', 'IT']),
    MedicalVisit: new feature_1.Feature(['FR', 'IT']),
    MinCoeffChecking: new feature_1.Feature(['FR', 'IT']),
    MissionBillRate: new feature_1.Feature(['US']),
    MissionConstraint: new feature_1.Feature(['FR', 'IT']),
    MissionDifficultyFactors: new feature_1.Feature(['FR', 'IT']),
    MissionFlatRatePlacement: new feature_1.Feature(['FR']),
    MissionJobLevel: new feature_1.Feature(['FR', 'IT']),
    MissionJobPosition: new feature_1.Feature(['FR', 'IT']),
    MissionLowSalaryRangePlacement: new feature_1.Feature(['FR', 'US']),
    MissionManagementStatus: new feature_1.Feature(['FR', 'IT']),
    MissionMonthlyBonusPlacement: new feature_1.Feature(['FR', 'US']),
    MissionOpsComment: new feature_1.Feature(['FR', 'IT']),
    MissionPlanningType: new feature_1.Feature(['FR', 'IT']),
    MissionRiskIndicator: new feature_1.Feature(['FR', 'IT']),
    MissionRiskFactors: new feature_1.Feature(['FR']),
    MissionSalaryComment: new feature_1.Feature(['FR', 'IT']),
    NightRangeHours: new feature_1.Feature(['FR', 'IT']),
    PaymentOptions: new feature_1.Feature(['FR', 'IT']),
    PaymentSettings: new feature_1.Feature(['FR']),
    PayrollSystemPlaces: new feature_1.Feature(['FR']),
    Reimbursement: new feature_1.Feature(['FR']),
    SecurityTrainings: new feature_1.Feature(['FR']),
    ShiftCV3CommentMonitoring: new feature_1.Feature(['IT']),
    SmicChecking: new feature_1.Feature(['FR']),
    StartSheet: new feature_1.Feature(['US']),
    TimesheetDeclarativeOptions: new feature_1.Feature(['FR', 'IT']),
    TimesheetReminders: new feature_1.Feature(['FR', 'IT']),
    WorkerIdentityDocument: new feature_1.Feature(['FR', 'IT']),
    WorkerNationality: new feature_1.Feature(['FR', 'IT']),
    WorkerRace: new feature_1.Feature(['US']),
    WorkerVeteranStatus: new feature_1.Feature(['US']),
    WorkerBehaviorWarnings: new feature_1.Feature(['FR', 'IT']),
    WorkerLocationCarpooling: new feature_1.Feature(['FR', 'IT']),
    WorkerPaymentAccountType: new feature_1.Feature(['US']),
    WorkerBankName: new feature_1.Feature(['US']),
    WorkerMarketingCampaignTracking: new feature_1.Feature(['FR', 'IT']),
    NewWorkerProfilePage: new feature_1.Feature(['US']),
    WorkerCreationPrimaryPaymentFields: new feature_1.Feature(['FR', 'IT']),
    ShiftReasonAnticipatedCustomerStopRestriction: new feature_1.Feature(['FR']),
    TemporaryMissionWithoutEndDate: new feature_1.Feature(['US']),
    ShiftRenewed: new feature_1.Feature(['FR', 'IT']),
    ShiftAnnualSalary: new feature_1.Feature(['FR', 'IT']),
};
